<template>
  <div class="regionSelectBoxWrapper" v-bind:class="{citySelected: regionId !== 0}">
    <select v-model="regionId" class="citySelectBox" v-on:change="setDistrictList">
      <option v-bind:value="0" v-bind:disabled="true" hidden>지역을 선택해주세요</option>
      <option v-for="region in regionList" v-bind:key="region.id" v-bind:value="region.id">{{ region.name }}</option>
    </select>
    <select v-model="districtId" class="citySelectBox" v-on:change="saveDistrictId" v-show="regionId !== 0">
      <option v-for="district in districtList" v-bind:key="district.id" v-bind:value="district.id">{{ district.name }}</option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    regionCount: Number
  },
  data () {
    return {
      regionList: null,
      districtList: null,
      regionId: 0,
      districtId: 0,
      allDistrictList: null // 임시저장에서 불러왔을시 (저장된 지역정보가 있을 시)에만 활성화
    }
  },
  methods: {
    setDistrictList: function () {
      // 구역2 selectBox obtion만들기
      let beforeDistrictsAll = this.$store.getters.getEnrollStateValue('area')
      let beforeDistricts = beforeDistrictsAll.filter(arr => arr != null)
      this.removeDuplicatedDistrict(beforeDistricts, this.regionId)

      this.$store.commit('setEnrollStateValue', {type: 'area', index: this.regionCount, value: this.districtList[0].id})
      this.$store.commit('setAreaSelectedTrigger')
      this.districtId = this.districtList[0].id
    },
    saveDistrictId: function () {
      this.$store.commit('setEnrollStateValue', {type: 'area', index: this.regionCount, value: this.districtId})
      this.$store.commit('setAreaSelectedTrigger')
    },
    removeDuplicatedRegion: function (beforeDistricts) {
      let regionList = this.$store.getters.getRegionList
      let removedRegion = JSON.parse(JSON.stringify(regionList))
      for(var i = 0; i < beforeDistricts.length; i++) {
        if(beforeDistricts[i] < 0 && this.regionCount !== i) {
          // 자신의 인덱스가 아니고 지역 전체선택일 경우
          let idx = removedRegion.indexOf(removedRegion.find(items => items.id === beforeDistricts[i] * -1))
          if (idx > -1) {
            removedRegion.splice(idx, 1)
          }
        }
      }
      this.regionList = removedRegion
    },
    removeDuplicatedDistrict: function (beforeDistricts, regionId) {
      let regionName = this.$store.getters.getRegionList.find(items => items.id === regionId).name
      let districtList = this.$store.getters.getDistrictAllList.filter(items => items.regionName === regionName)
      let removedDistrict = JSON.parse(JSON.stringify(districtList))
      let all = {
        countryName: '대한민국',
        name: '전체',
        id: regionId * -1,
        regionName: this.regionList.find(items => items.id === regionId) != null ? this.regionList.find(items => items.id === regionId).name : 'none'
      }
      removedDistrict.unshift(all)

      for(var i = 0; i < beforeDistricts.length; i++) {
        if(beforeDistricts[i] > 0 && this.regionCount !== i) {
          // 자신의 인덱스가 아니고 지역구 선택일 경우
          let idx = removedDistrict.indexOf(removedDistrict.find(items => items.id === beforeDistricts[i]))
          if (idx > -1) {
            removedDistrict.splice(idx, 1)

            let allIdx = removedDistrict.indexOf(removedDistrict.find(items => items.id === regionId * -1))
            if(allIdx > -1) {
              // 전체 항목이 남아있다면 전체 항목도 삭제
              removedDistrict.splice(allIdx, 1)
            }
          }
        }
      }
      this.districtList = removedDistrict
    }
  },
  created: function () {
    let formattedAreas = this.$store.getters.getEnrollStateValue('area')
    this.removeDuplicatedRegion(formattedAreas)
    if(formattedAreas.length !== 0) {
      // eslint-disable-next-line no-redeclare
      for(var i = 0; i < formattedAreas.length; i++) {
        if(this.regionCount === i && formattedAreas[i] != null) {
          this.allDistrictList = this.$store.getters.getDistrictAllList
          let regionName
          if(formattedAreas[i] < 0) {
            // -값 : 전체목록의 경우
            this.regionId = formattedAreas[i] * -1
            regionName = this.regionList.find(items => items.id === formattedAreas[i] * -1).name
          }else{
            // +값 : 지역1개
            regionName = this.allDistrictList.find(items => items.id === formattedAreas[i]).regionName
            this.regionId = this.regionList.find(items => items.name === regionName).id
          }

          let districtList = this.$store.getters.getDistrictAllList.filter(items => items.regionName === regionName)
          this.districtList = JSON.parse(JSON.stringify(districtList))
          let all = {
            countryName: '대한민국',
            name: '전체',
            id: this.regionId * -1,
            regionName: regionName
          }
          this.districtList.unshift(all)
          this.districtId = formattedAreas[i]

          if(this.regionId !== 0) {
            // 지역구 중복 삭제
            this.removeDuplicatedDistrict(formattedAreas, this.regionId)
          }
        }
      }
    }
  },
  mounted: function () {
    this.$store.watch(() => this.$store.getters.getAreaSelectedTrigger, value => {
      let beforeDistrictsAll = this.$store.getters.getEnrollStateValue('area')
      this.removeDuplicatedRegion(beforeDistrictsAll)
      if(this.regionId !== 0) {
        this.removeDuplicatedDistrict(beforeDistrictsAll, this.regionId)
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.regionSelectBoxWrapper{
  display : -webkit-flex;
  display: flex;
  justify-content: start;
  width: 200px;
}

.citySelectBox{
  font-size: 13px;
  margin: 0 40px 20px 0;
  padding-bottom: 10px;
  border: none;
  border-bottom: rgb(112,112,112) 2px solid;
  outline: none;
  width: 160px;
}

.citySelected{
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/regionSelectBox.vue